<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">호스트 목록</div>
      </div>
      <div class="vertical-center-box" align="right">
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper ref="hostTable" :column-default="columnDefault" :data="tableData" :columns="tableColumns"
      :show-search-tool="showSearchTool" :show-custom-header="true" remote pagination :total="total" @condition-change="loadData">
    </el-table-wrapper>
  </div>
</template>

<script>
import { isNil } from 'lodash';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import provisioningSettingApi from '@/api/settings/virtual/provisioning-settings';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WVirtualCenterTable',
  props: {
    selectedNode: {
      type: Object,
    },
    isLeaf: {
      type: Boolean,
    },
  },
  data() {
    const tableColumns = [
      {
        prop: 'hostName',
        label: '호스트명',
        searchable: true,
        sortable: true,
        formatter: defaultFormatter,
      },
      {
        prop: 'hypervisorType',
        label: '하이퍼바이저 종류',
        searchable: true,
        sortable: true,
        formatter: defaultFormatter,
      },
      {
        prop: 'iprangeCount',
        label: 'IP관리범위 수',
        formatter: defaultFormatter,
      },
      {
        prop: 'totalCount',
        label: '전체',
        formatter: defaultFormatter,
      },
      {
        prop: 'userate',
        label: '사용률',
        formatter: (row, column, value) => {
          if (isNil(value)) return EMPTY_TEXT;
          const percentage = Number(value) * 100;
          return `${parseFloat(percentage).toFixed(2)}%`;
        },
      },
      {
        prop: 'usedCount',
        label: '사용',
        formatter: defaultFormatter,
      },
      {
        prop: 'unusedCount',
        label: '미사용',
        formatter: defaultFormatter,
      },
    ];
    return {
      total: null,
      selectedRow: null,
      popupParams: {},
      tableData: [],
      tableColumns,
      checkedRows: [],
      showSearchTool: false,
      columnDefault,
    };
  },
  watch: {
    selectedNode() {
      if (!this.isLeaf) {
        this.loadData();
      }
    },
  },
  methods: {
    loadData() {
      const tableParams = this.$refs.hostTable.getParameter();
      provisioningSettingApi.getVirtualcenterHostIpList({
        virtualcenterGroupId: this.selectedNode.treeKey,
        ...tableParams,
      }).then((response) => {
        if (response.data.success) {
          this.tableData = response.data.data;
          this.total = response.data.total;
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/virtual/Provisioning/IpRangeSetting/components/VirtualCenterTable.vue